import { getTermsUseInfo } from 'reduxStore/actions/termsOfUse';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  userLoading: false,
  termsDetails: [],
  error: null,
};
const termsUseSlice = createSlice({
  name: 'termsUse',
  initialState,
 reducers:{},
  extraReducers: (builder) => {
    builder
      .addCase(getTermsUseInfo.fulfilled, (state, action) => {
        state.userLoading = false;
        state.termsDetails = action.payload;
      })
      .addCase(getTermsUseInfo.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getTermsUseInfo.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});
export default termsUseSlice.reducer;
